import type { QuestionData } from '../types';

export function fingerprintFormTranslateSource(
  questions: QuestionData[],
  categoryName: string,
  categoryDescription: string,
): string {
  const sorted = [...questions].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  return JSON.stringify({
    cn: categoryName.trim(),
    cd: categoryDescription.trim(),
    qs: sorted.map((q) => ({
      id: q.id,
      order: q.order,
      qt: (q.questionText ?? '').trim(),
      ds: (q.description ?? '').trim(),
      qType: q.questionType ?? '',
      opts: (q.options ?? []).map((o, idx) => ({
        id: o.id,
        idx,
        t: (o.text ?? '').trim(),
      })),
    })),
  });
}
